if (!customElements.get('sticky-add-to-cart')) {
  customElements.define(
    'sticky-add-to-cart',
    class StickyAddToCart extends HTMLElement {
      constructor() {
        super();

        this.stickyBar = this;
        this.addBtnWrap = this.querySelector('.sticky-atc-bar__add-btn-wrap');
        this.addBtn = this.querySelector('.sticky-atc-bar__add-btn');
        this.btnText = this.querySelector('.sticky-atc-bar__btn-text');
        this.successBlock = this.querySelector('.sticky-atc-bar__success');
        this.spacer = document.querySelector('.sticky-atc-bar-spacer');
        this.variantIdInput = this.querySelector('[name="sticky-variant-id"]');

        this.originalBuyButtons = document.querySelector(
          'product-info[data-section="' + this.dataset.section + '"] .product-form__submit'
        );

        this.addBtn.addEventListener('click', this.onAddToCart.bind(this));

        this.variantChangeUnsubscribe = subscribe(
          PUB_SUB_EVENTS.variantChange,
          this.onVariantChange.bind(this)
        );

        this.initVisibility();
      }

      disconnectedCallback() {
        if (this.variantChangeUnsubscribe) this.variantChangeUnsubscribe();
        if (this.scrollObserver) this.scrollObserver.disconnect();
      }

      initVisibility() {
        var self = this;
        var target = this.originalBuyButtons
          || document.querySelector(
               'product-info[data-section="' + this.dataset.section + '"]'
             );
        if (!target) return;

        this.hasScrolled = false;
        function onFirstScroll() {
          self.hasScrolled = true;
          window.removeEventListener('scroll', onFirstScroll);
        }
        window.addEventListener('scroll', onFirstScroll, { passive: true });

        this.scrollObserver = new IntersectionObserver(
          function(entries) {
            for (var i = 0; i < entries.length; i++) {
              if (entries[i].isIntersecting) {
                self.hide();
              } else if (self.hasScrolled) {
                self.show();
              }
            }
          },
          { threshold: 0 }
        );

        this.scrollObserver.observe(target);
      }

      show() {
        this.stickyBar.classList.add('is-visible');
        if (this.spacer) this.spacer.classList.add('is-active');
      }

      hide() {
        this.stickyBar.classList.remove('is-visible');
        if (this.spacer) this.spacer.classList.remove('is-active');
      }

      onVariantChange(event) {
        if (event.data && event.data.variant) {
          var variant = event.data.variant;
          this.variantIdInput.value = variant.id;

          if (variant.available) {
            this.addBtn.removeAttribute('disabled');
            this.btnText.textContent = window.variantStrings.addToCart;
          } else {
            this.addBtn.setAttribute('disabled', 'disabled');
            this.btnText.textContent = window.variantStrings.soldOut;
          }

          this.resetToAddState();
        }
      }

      onAddToCart() {
        if (this.addBtn.getAttribute('disabled') === 'disabled') return;
        if (this.addBtn.classList.contains('loading')) return;

        this.addBtn.classList.add('loading');
        var spinner = this.addBtn.querySelector('.loading__spinner');
        if (spinner) spinner.classList.remove('hidden');

        var variantId = this.variantIdInput.value;
        var config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        var formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', '1');
        formData.append('sections', 'cart-icon-bubble,cart-drawer');
        formData.append('sections_url', window.location.pathname);

        config.body = formData;

        var self = this;

        fetch(routes.cart_add_url, config)
          .then(function(r) {
            return r.json();
          })
          .then(function(data) {
            if (data.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'sticky-add-to-cart',
                productVariantId: variantId,
                errors: data.errors || data.description,
                message: data.message
              });
              return;
            }

            if (data.sections) {
              var sectionHtml = data.sections['cart-icon-bubble'];
              if (sectionHtml) {
                var bubbleEl = document.getElementById('cart-icon-bubble');
                if (bubbleEl) {
                  var doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
                  var sec = doc.querySelector('.shopify-section');
                  if (sec) {
                    bubbleEl.innerHTML = sec.innerHTML;
                  }
                }
              }

              var drawerHtml = data.sections['cart-drawer'];
              if (drawerHtml) {
                var cartDrawerEl = document.getElementById('CartDrawer');
                if (cartDrawerEl) {
                  var drawerDoc = new DOMParser().parseFromString(drawerHtml, 'text/html');
                  var drawerSec = drawerDoc.querySelector('#CartDrawer');
                  if (drawerSec) {
                    cartDrawerEl.innerHTML = drawerSec.innerHTML;

                    var newOverlay = cartDrawerEl.querySelector('#CartDrawer-Overlay');
                    var parentDrawer = document.querySelector('cart-drawer');
                    if (newOverlay && parentDrawer) {
                      newOverlay.addEventListener('click', parentDrawer.close.bind(parentDrawer));
                    }
                  }
                }
              }
            }

            var cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer) {
              cartDrawer.classList.remove('is-empty');
            }
            var drawerItems = document.querySelector('cart-drawer-items');
            if (drawerItems) {
              drawerItems.classList.remove('is-empty');
            }

            self.showSuccess();

            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'sticky-add-to-cart',
              productVariantId: variantId,
              cartData: data
            });
          })
          .catch(function(e) {
            console.error(e);
          })
          .finally(function() {
            self.addBtn.classList.remove('loading');
            var sp = self.addBtn.querySelector('.loading__spinner');
            if (sp) sp.classList.add('hidden');
          });
      }

      showSuccess() {
        this.addBtnWrap.classList.add('is-hidden');
        this.successBlock.classList.add('is-active');
      }

      resetToAddState() {
        this.addBtnWrap.classList.remove('is-hidden');
        this.successBlock.classList.remove('is-active');
      }
    }
  );
}
